import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="max-w-3xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-extrabold text-ink-900 mb-6">Privacy Policy</h1>
      <p className="mb-4 text-gray-700">
        <strong>Last updated:</strong> June 10, 2025
      </p>
      <p className="mb-4 text-gray-700">
        Thank you for visiting MyOrgLab. Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your information when you use our website.
      </p>
      <h2 className="text-xl font-bold text-brand-600 mt-8 mb-2">What Information We Collect</h2>
      <p className="mb-4 text-gray-700">
        When you visit our website, we may collect certain information automatically through cookies and similar technologies. This includes:
      </p>
      <ul className="list-disc list-inside mb-4 text-gray-700">
        <li>Pages you visit and actions you take on our site</li>
        <li>Your device type, browser, and operating system</li>
        <li>Your IP address (anonymized by Google Analytics)</li>
        <li>Referral source (how you arrived at our site)</li>
      </ul>
      <p className="mb-4 text-gray-700">
        We do <strong>not</strong> collect personally identifiable information unless you voluntarily provide it (e.g., through contact forms or newsletter sign-up).
      </p>
      <h2 className="text-xl font-bold text-brand-600 mt-8 mb-2">How We Use Cookies</h2>
      <p className="mb-4 text-gray-700">
        We use cookies to:
      </p>
      <ul className="list-disc list-inside mb-4 text-gray-700">
        <li>Analyze site usage and performance</li>
        <li>Improve your browsing experience</li>
        <li>Remember your cookie consent preferences</li>
      </ul>
      <p className="mb-4 text-gray-700">
        Cookies are small text files stored on your device. You can accept or decline cookies using the banner on our site.
      </p>
      <h2 className="text-xl font-bold text-brand-600 mt-8 mb-2">Google Analytics</h2>
      <p className="mb-4 text-gray-700">
        We use Google Analytics to understand how visitors interact with our website. Google Analytics collects information such as:
      </p>
      <ul className="list-disc list-inside mb-4 text-gray-700">
        <li>Which pages are visited and for how long</li>
        <li>How users navigate through the site</li>
        <li>General geographic location (city/country)</li>
      </ul>
      <p className="mb-4 text-gray-700">
        Google Analytics uses cookies to collect this data. All data is aggregated and anonymized; we do <strong>not</strong> use Google Analytics to collect personal information or track individual users.
      </p>
      <p className="mb-4 text-gray-700">
        You can learn more about how Google uses data{" "}
        <a
          href="https://policies.google.com/technologies/partner-sites"
          className="text-brand-600 underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          here
        </a>.
      </p>
      <h2 className="text-xl font-bold text-brand-600 mt-8 mb-2">Contact Form Security</h2>
      <p className="mb-4 text-gray-700">
        On our contact form, we use Cloudflare Turnstile to block automated spam. This is strictly necessary security: it helps us tell people apart from bots so we can keep the form working. To do this, Cloudflare processes technical signals from your browser, such as your IP address, browser and connection details (including the User-Agent header and TLS fingerprint), and the site you are on. Turnstile is not used for analytics or advertising, and it does not set cookies on our site. Cloudflare's processing is described in its{" "}
        <a
          href="https://www.cloudflare.com/turnstile-privacy-policy/"
          className="text-brand-600 underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          Turnstile Privacy Addendum
        </a>{" "}
        and{" "}
        <a
          href="https://www.cloudflare.com/privacypolicy/"
          className="text-brand-600 underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>.
      </p>
      <h2 className="text-xl font-bold text-brand-600 mt-8 mb-2">Managing Your Preferences</h2>
      <p className="mb-4 text-gray-700">
        You can accept or decline cookies at any time using the cookie consent banner. If you decline, Google Analytics and other non-essential cookies will not be activated.
      </p>
      <p className="mb-4 text-gray-700">
        You can also clear cookies from your browser at any time. Google Analytics loads only after you click Accept on the cookie banner. If you click Decline or make no choice, it does not load.
      </p>
      <h2 className="text-xl font-bold text-brand-600 mt-8 mb-2">Data Sharing</h2>
      <p className="mb-4 text-gray-700">
        We do <strong>not</strong> sell, trade, or otherwise transfer your personal information to outside parties. Data collected via Google Analytics is subject to Google’s privacy policy. Signals processed by Cloudflare Turnstile are subject to Cloudflare's privacy policy.
      </p>
      <h2 className="text-xl font-bold text-brand-600 mt-8 mb-2">Contact Us</h2>
      <p className="mb-4 text-gray-700">
        If you have any questions about this Privacy Policy or your data, please contact us at{" "}
        <a href="mailto:info@myorglab.com" className="text-brand-600 underline">
          info@myorglab.com
        </a>.
      </p>
      <hr className="my-8" />
      <p className="text-gray-600 text-sm">
        By using our website, you consent to this Privacy Policy.
      </p>
    </div>
  );
}